import cn from 'classnames';

import Icon from '@publicImages/svg/fly-out.svg?icon';

import type { TSvgIconProps } from '@/infra/types/common/picture';

const FlyOut = ({ className, ...props }: TSvgIconProps) => <Icon className={cn('FlyOut', className)} {...props} />;

export default FlyOut;
